export class Topic {
  id: number;
  subjectId: number;
  name: string;

  constructor(id: number, subjectId: number, name: string) {
    this.id = id;
    this.subjectId = subjectId;
    this.name = name;
  }
}

